import React from 'react'
import { Typography } from 'antd'
import PropTypes from 'prop-types'

import styles from './ConcessionVendorGridEditor.module.css'

const { Text } = Typography

const ConcessionVendorCardPreview = ({ vendor }) => {
  if (!vendor) {
    return (
      <div className={styles.previewCard}>
        <Text className={styles.previewLabel}>Preview</Text>
        <div className={styles.previewEmpty}>
          <Text type="secondary">Add a vendor to see the card preview.</Text>
        </div>
      </div>
    )
  }

  const name = vendor.name?.trim() || 'Vendor name'
  const description = vendor.description?.trim()
  const imageUrl = vendor.image?.url || vendor.image?.src || ''
  const imageAlt = vendor.image?.alt || name

  return (
    <div className={styles.previewCard}>
      <Text className={styles.previewLabel}>Preview</Text>
      <div className={styles.previewCardInner}>
        <div className={styles.previewImageWrap}>
          {imageUrl ? (
            <img alt={imageAlt} className={styles.previewImage} src={imageUrl} />
          ) : (
            <div className={styles.previewImagePlaceholder}>No image</div>
          )}
        </div>
        <div className={styles.previewBody}>
          <div className={styles.previewName}>{name}</div>
          {description && (
            <div className={styles.previewDescription}>{description}</div>
          )}
        </div>
      </div>
    </div>
  )
}

ConcessionVendorCardPreview.propTypes = {
  vendor: PropTypes.object
}

export default ConcessionVendorCardPreview
